// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Tlcm","consentsList":"PatientConsents_consentsList__1TZ9k","consentsListEmpty":"PatientConsents_consentsListEmpty__38W27"};